import React from "react";
import Hero from "@insightfulscience/atomic-react/Hero";
import HeroTitle from "@insightfulscience/atomic-react/Hero/Title";
import GuidePageTemplate from "@insightfulscience/atomic-react/GuidePageTemplate";
import GuidePageTemplateMain from "@insightfulscience/atomic-react/GuidePageTemplate/Main";
import {
	PostElementParagraph,
	PostElementOl,
	PostElementListItem,
	PostElementTitleH3,
} from "@insightfulscience/atomic-react/PostElement";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import { useLocale } from "@insightfulscience/smart-react/i18";
import Html from "@insightfulscience/smart-react/Html";
import SiteLayout from "../../SiteLayout";
import { list1, list2, list3 } from "./texts";

const isList = list => list && Array.isArray(list) && list.length > 0;

const renderList = (list, t, type = "default") => {
	if (!isList(list)) return null;

	return (
		<PostElementOl type={type}>
			{list.map(({ text, subList, ...rest }) => {
				return (
					<PostElementListItem key={text}>
						<Html Tag="span">{t(text, rest)}</Html>
						{isList(subList) && renderList(subList, t)}
					</PostElementListItem>
				);
			})}
		</PostElementOl>
	);
};

const TermsOfService = () => {
	const [t] = useLocale("terms-of-service");
	return (
		<SiteLayout>
			<PageMeta title={t("META.TITLE")} description={t("META.DESCRIPTION")}>
				<PageMeta.OGP title={t("META.TITLE")} description={t("META.DESCRIPTION")} />
				<PageMeta.Canonical href={t("META.CANONICAL")} />
			</PageMeta>

			<Hero color="4" spacing={{ py: 18 }}>
				<HeroTitle>{t("HERO_TITLE")}</HeroTitle>
			</Hero>

			<GuidePageTemplate sidebar={false}>
				<GuidePageTemplateMain sidebar={false}>
					<PostElementParagraph>{t("LAST_UPDATE")}</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("DESCRIPTION_1")}</Html>
					</PostElementParagraph>
					{renderList(list1, t, "dotted")}

					<PostElementTitleH3 center spacing={{ mt: 20 }}>
						{t("ATTACHMENT_1")}
					</PostElementTitleH3>
					{renderList(list2, t, "dotted")}

					<PostElementTitleH3 center spacing={{ mt: 20 }}>
						{t("ATTACHMENT_2")}
					</PostElementTitleH3>
					{renderList(list3, t, "dotted")}
				</GuidePageTemplateMain>
			</GuidePageTemplate>
		</SiteLayout>
	);
};

export default TermsOfService;
